/**
 * NSM site Hero — event text/date/venue from config/site.js, image from config or assets/branding.
 * Keeps existing main-slider markup and Swiper for styling.
 */
import React from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { site } from "../../config/site";

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 1,
  loop: false,
  effect: "fade",
  pagination: {
    el: "#main-slider-pagination",
    type: "bullets",
    clickable: true,
  },
  navigation: {
    nextEl: "#main-slider__swiper-button-next",
    prevEl: "#main-slider__swiper-button-prev",
  },
  autoplay: { delay: 7000, disableOnInteraction: false },
};

export default function Hero() {
  return (
    <section id="th-home" className="main-slider">
      <Swiper {...swiperOptions} className="swiper-container thm-swiper__slider">
        <div className="swiper-wrapper">
          <SwiperSlide className="swiper-slide main-slider--nsm-centered">
            {/* Hero image temporarily disabled — centered text-only layout */}

            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-10 col-lg-10">
                  <div className="main-slider__content main-slider__content--centered">
                    <p className="main-slider__sub-title">{site.heroSubtitle}</p>
                    <h2 className="main-slider__title">{site.heroTitle}</h2>
                    <p className="main-slider__text">{site.heroTagline}</p>
                    <ul className="list-unstyled main-slider__address">
                      <li>
                        <div className="icon"><span className="icon-pin"></span></div>
                        <div className="text"><p>{site.dateLocationTeaser}</p></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </div>
      </Swiper>
      <div className="swiper-pagination" id="main-slider-pagination" />
    </section>
  );
}
